"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.carImageStyles = {
    backgroundImageRoot: {
        width: '100%',
        height: '100%',
        paddingTop: 0,
        clipPath: 'polygon(0 100%,0 0,100% 0,85% 100%)',
        marginRight: '-10%',
    },
    backgroundImage: {
        objectFit: 'cover',
        minHeight: '100%',
    },
    interiorImageRoot: {
        width: '100%',
        height: '100%',
        paddingTop: 0,
        clipPath: 'polygon(0 100%,15% 0,100% 0,100% 100%)',
    },
    interiorImage: {
        objectFit: 'cover',
        minHeight: '100%',
    },
    vehicleImageRoot: {
        paddingTop: 0,
        position: 'absolute',
        top: 50,
        backgroundColor: 'unset',
        width: '100%',
        height: '100%',
    },
    vehicleImage: {
        position: 'relative',
        width: 500,
        height: 200,
        display: 'block',
        margin: 'auto',
        top: '25%',
        transform: 'translateY(-25%)',
    },
    withSpecialBackground: {
        position: 'relative',
        paddingTop: 0,
    },
    vehicleImageithSpecialBackground: {
        position: 'relative',
        width: 500,
        height: 200,
        display: 'block',
        margin: 'auto',
    },
};
var carImageWithBgStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return ({
        imageContainer: {
            position: 'relative',
            margin: '25px 0',
            paddingBottom: '25px',
        },
        bgContainer: (_a = {
                height: 200,
                width: 500,
                display: 'flex',
                position: 'relative',
                margin: 'auto'
            },
            _a[theme.breakpoints.down(theme.breakpoints.values.sm)] = {
                width: '100%',
                height: 145,
            },
            _a),
    });
}, { name: 'Summary_CarImageWithBg' });
exports.default = carImageWithBgStyles;
